export const statuses = [
  { value: 'pending', label: 'Pending' },
  { value: 'failed', label: 'Failed' },
  { value: 'completed', label: 'Completed' },
];
